export const CREATE_ACTIVITY_FORM_NAME = 'createProtrackActivity'
export const EDIT_ACTIVITY_FORM_NAME = 'editProtrackActivity'
export const ACTIVITIES_LIST_FORM_NAME = 'activitiesListFormName'
export const ACTIVITY_TEMPLATE = `Name,Description,Proquote,Proquote Author,Story Question,domain__fileName,Category Tag
Name,Description,Proquote,Proquote Author,Story Question,domain__fileName,Category Tag
Name,Description,Proquote,Proquote Author,Story Question,domain__fileName,Category Tag`
export const CREATE_STORY_FORM_NAME = 'createStory'
export const USER_ACTIVITY_DONE_PANEL_FORM = 'userActivityDonePanelForm'
